// extracted by mini-css-extract-plugin
export default {"title-section":"fX2jlfukC+","titleSection":"fX2jlfukC+","table":"QatQK84Y1Z","status":"kFJDhLjxEn"};
    if(module.hot) {
      // 1648553770649
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  